module.exports = {"370983001":"新城街道","370983002":"老城街道","370983003":"王瓜店街道","370983004":"仪阳街道","370983101":"潮泉镇","370983103":"桃园镇","370983104":"王庄镇","370983105":"湖屯镇","370983106":"石横镇","370983107":"安临站镇","370983108":"孙伯镇","370983109":"安驾庄镇","370983110":"汶阳镇","370983111":"边院镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370983.json
// module id = 1560
// module chunks = 0